import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAlert } from '../../hooks/useAlert';

const LoginScreen = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { showAlert } = useAlert();

    // --- FIX START ---
    // While the app is checking the user's session, show a loading message.
    if (auth.isLoading) {
        return <div>Verifying session...</div>;
    }

    // If the check is complete and the user IS authenticated, redirect them away.
    if (auth.isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    // --- FIX END ---

    const redirectPath = new URLSearchParams(location.search).get('redirect') || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await auth.login(username, password);
            navigate(redirectPath, { replace: true });
        } catch (error) {
            showAlert(error.response?.data?.message || 'Login failed. Please try again.');
        }
    };

    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>Login to ichrahly meet</h1>
            <form onSubmit={handleSubmit}>
                {/* Form fields remain the same */}
                <div>
                    <label htmlFor="username">Username</label>
                    <input
                        id="username"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        aria-required="true"
                    />
                </div>
                <div>
                    <label htmlFor="password">Password</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        aria-required="true"
                    />
                </div>
                <button type="submit">Log In</button>
            </form>
        </div>
    );
};

export default LoginScreen;
